import script from "./ContactFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFormModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactFormModal.vue?vue&type=style&index=0&id=4008a345&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4008a345"]])

export default __exports__